import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSection, TutorialSlide } from "../../tutorial.models";

export const CODING_SETTINGS_SLIDES: TutorialSlide[] = [
    {
        key: 'Welcome-Coding',
        title: 'Coding Settings! 👋',
        messages: [{ text: "Linking procedure codes to medical services is essential for health professionals to ensure they get paid properly. However, tracking these codes can be time-consuming, and it's easy to miss codes or make errors, which can ultimately impact your practice's bottom line. MedicAI streamlines this process by automating the collection of your codes into an exportable file for any desired time period—quick and simple! To get your AI Assistant set up for code collection, we'll need to configure some coding settings. Users who implement this workflow with MedicAI save hours of administrative time every week." }],
        actions: [
            {
                text: 'Get Started',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.AUTO_WARD_BUNDLES_ADDED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.CODING_BUNDLES_ADDED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.COMMON_MODIFIER_ADDED, type: SlideHideConditionType.AND },
        ],
    },
    {
        key: 'Add-autoCoding',
        title: 'Automatic Ward Coding',
        messages: [
            { text: "Automatic Ward Coding will take care of adding procedure codes for patients currently admitted to your wards. Just assign the relevant procedure code to the ward admission, for example, use code 0109 for a ward patient." },
            { text: "Note: The wards in this menu are pulled from the ones you've added to your Associated Hospitals in the Profile Menu, so make sure that's set up correctly!" },
        ],
        expansionTarget: 'WARD_CODING',
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.AUTO_WARD_BUNDLES_ADDED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-Coding-Bundles',
        title: 'Coding Bundles',
        messages: [
            { text: "With Coding Bundles, you can create a set of codes for frequently performed procedures — whether in your office, at the bedside, or in the operating room. Just name the bundle (be as accurate and descriptive as possible) and add the relevant procedure codes. Your AI Assistant will then assign the appropriate coding bundles and associated procedure codes to your generated procedure notes. After a quick review, these will be added to your ongoing work-related procedure coding." },

        ],
        expansionTarget: 'CODING_BUNDLE',
        highlightTarget: 'CODING_BUNDLE',
        //forceOpenTarget: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.CODING_BUNDLES_ADDED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-Common-IDs',
        title: 'Common Modifiers',
        expansionTarget: 'COMMON_MODIFIERS',
        highlightTarget: 'CLEAR',
        messages: [
            { text: "Modifiers allow you to list frequent code modifiers you use for billing. This will alert your AI Assistant to prioritize these modifiers in your coding recommendations." },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.COMMON_MODIFIER_ADDED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Coding-Finish',
        title: 'Completed Coding Settings!',
        messages: [
            { text: "You are 95% done!" },
        ],
        highlightTarget: 'CLEAR',
        hasBackdrop: true,
        //position: { vertical: 'center', horizontal: 'center' },
        dimensions: { width: '450px' },
        actions: [
            {
                text: 'Carry on - Recommended',
                color: 'primary',
                actionName: SlideAction.START_NETWORK_TUTORIAL
            },
            {
                text: 'Continue Later',
                color: 'warn',
                actionName: SlideAction.CLOSE_TUTORIAL,
                suffixText: 'Continue Later'
            },

        ],
        position: { x: 700, y: 350 },
        hideDoNotShowAgain: true,
        progressBar: 85,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.AUTO_WARD_BUNDLES_ADDED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.CODING_BUNDLES_ADDED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.COMMON_MODIFIER_ADDED, type: SlideHideConditionType.AND },
        ],
    },
];